
let xxl = 2000
// let screenWidth = $(window).width()
let screenWidth = window.innerWidth


//Can rewrite to viewpoints
if (screenWidth > xxl) {
    let fontCoef = screenWidth / 1440
    let fontSize = Math.floor(16 * fontCoef)
    fontSize = fontSize > 32 ? 32 : fontSize
    $('html').css('font-size', fontSize + 'px')
}

/** Sidebar menu follow **/
